package com.qrkontaq.pages.m

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.qrkontaq.core.tenant.Tenant
import com.qrkontaq.ui.tenant.MenuScreen
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext

/**
 * Deep link to a menu category: cafename.qrkontaq.com/m/{slug}?t={table}.
 * Used for category-specific QR codes (bar menu, lunch menu) and link sharing.
 */
@Page("{slug}")
@Composable
fun CategoryPage() {
    val context = rememberPageContext()
    val tenantSlug = Tenant.slug

    if (tenantSlug == null) {
        LaunchedEffect(Unit) { context.router.navigateTo("/") }
        return
    }

    MenuScreen(
        slug = tenantSlug,
        tableLabel = context.route.params["t"],
        categorySlug = context.route.params["slug"],
    )
}
